import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class filterTagType_template extends vnTemplate {


    static SINGLE_SELECTION_MODE: string = 'single';
    static MULTIPLE_SELECTION_MODE: string = 'multiple';

    protected tagContainerId: string = 'selected-tag-types';
    protected tagContainerCaption: string = 'Selected Tag Types:';

    protected getTemplateHtml(): string {

        return `
                <div class="w-spec-search icon i-auto-complete i-tag-a">
                    <input data-bind="textInput: tagType, event: { keyup: onChangeInput}, disable: idTagType() != null, valueUpdate : 'afterkeydown', attr:{id:idTagType}" placeholder="Tag Type" list="tagTypes" class="input-text">
                        <ul class="form-auto-list" data-bind="foreach: tagTypes, visible: isShowTagTypeSuggestions, attr : {id: idFilter() + '-tagTypes'}" >
                            <li class="form-auto-item" data-bind="attr:{id:id}, text: $data.name + ' ' + $data.formattedDataset, click: $parent.onBlurTagType" ></li>
                        </ul>
                    </input>
                    <button data-bind="event: { click: onClearInput }, attr: { id: idFilter() + '-input-close'}" class="close-btn icon i-x-after" type="button"><span class="hidden-text">close</span></button>
                </div>
                `;
    }

    protected getTemplateName(): string {
        return "filterTagType-template";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected initPartial() {
        this.getTemplateViewModel().idFilter(this.idElement);
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let self = this;
        return {
            selectionMode:ko.observable(filterTagType_template.SINGLE_SELECTION_MODE),
            tagTypes: ko.observableArray([]),
            idTagType: ko.observable(null),
            idFilter: ko.observable(),
            tagType: ko.observable(""),
            tagTypeObj: ko.observable(null),
            tagTypeObjs: ko.observableArray(null),
            orderBy: "dateCreation",
            orderByDirection: "DESC",
            isShowTagTypeSuggestions: ko.observable(false),
            onChangeInput: (data, event): void => {
                self.onChangeInput(data, event);
            },
            onClearInput: (data, event): void => {
                self.onClearInput(event);
            },
            onChangeFilterAction: (data, event): void => {
                self.onChangeFilterAction(data)
            },
            onBlurTagType: (data, event): void => {
                self.onBlurTagType(data, event);
            }
        };
    }

    protected onChangeFilterAction(data) {
        this.caller.filterSimpleOnChange(this.idElement);
    }

    protected onChangeInput(data, event) {
        let input = event.target;
        let inputWrapper = input.parentNode;
        let closeBtn = inputWrapper.querySelector('#' + this.idElement + '-input-close');
        if (!closeBtn.classList.contains('is-showing')) {
            closeBtn.classList.add('is-showing');
        }
        this.onChangeTagDataListTag(event, this.viewModel[this.idElement].idTag);
    }

    protected onChangeTagDataListTag(event, idTag) {
        let input = event.target,
            inputVal = input.value,
            options: any = document.getElementById(this.idElement + "-tagTypes").childNodes;

        if (inputVal.length >= 2) {
            this.caller.getTagTypesSuggestion(inputVal, this.idElement);
            this.getTemplateViewModel().isShowTagTypeSuggestions(true);

        }
        for (let op of options) {
            if (op.value === inputVal) {
                idTag(op.id);
                input.blur();
                this.caller.filterSimpleOnChange(this.idElement);
                break;
            }
        }
    }

    protected onClearInput(event) {
        let button = event.target;
        if (button.classList.contains('is-showing')) {
            button.classList.remove('is-showing');
            this.viewModel[this.idElement].idTagType(null);
            this.viewModel[this.idElement].tagType("");
            this.viewModel[this.idElement].tagTypes([]);
            this.viewModel[this.idElement].tagTypeObj("");
            this.viewModel[this.idElement].isShowTagTypeSuggestions(false);
            this.caller.filterSimpleOnChange(this.idElement);

        }
    }

    public clearInput() {
        let button = document.getElementById(this.idElement + "-input-close");
        if (button.classList.contains('is-showing')) {
            button.classList.remove('is-showing');
        }
        this.setIdTagType(null);
        this.setTagType('');
        this.setTagTypes([]);
        this.setTagTypeObj('');
        this.setIsShowTagTypeSuggestions(false);
    }

    protected onBlurTagType(data, event) {

        this.setTagType(data.name);
        this.setTagTypeObj(data);
        this.setIdTagType(data.id);

        this.handleSelectionModeSpecific(data);

        this.setTagTypes([]);
        this.setIsShowTagTypeSuggestions(false);
        this.caller.filterSimpleOnChange(this.idElement);
    }
    private handleSelectionModeSpecific(data): void {

        if (this.isMultipleSelectionMode()) {
            if (this.getTagTypeObjs().length == 0) {
                this.addCaption();
            }
            this.appendTagToSelection(data);
            this.clearInput();
        } else {
            this.replaceTagInSelection(data);
        }
    }

    private appendTagToSelection(tagType): void {
        let tagTypeObjs = this.getTagTypeObjs();
        let filtered = tagTypeObjs.filter((t) => t.id == tagType.id);
        if (filtered.length == 0) {

            tagTypeObjs.push(tagType);
            this.addHtmlTag(tagType);
            this.setTagTypeObjs(tagTypeObjs);
        }
    }


    private removeTagFromSelection(tagTypeId): void {
        let tagTypes = this.getTagTypeObjs().filter((tt) => tt.id != tagTypeId);
        this.setTagTypeObjs(tagTypes);
    }

    private replaceTagInSelection(tagType): void {
        this.setTagTypeObjs([]);
        this.setTagTypeObjs([tagType]);
    }

    public asMultipleSelectionMode(): void {
        this.setSelectionMode(filterTagType_template.MULTIPLE_SELECTION_MODE);
    }

    public isMultipleSelectionMode(): boolean {
        return this.isSelectionMode(filterTagType_template.MULTIPLE_SELECTION_MODE);
    }

    public isSingleSelectionMode(): boolean {
        return this.isSelectionMode(filterTagType_template.SINGLE_SELECTION_MODE);
    }

    public isSelectionMode(selectionMode: string): boolean {
        return (this.getSelectionMode() == selectionMode);
    }

    public setTagContainerId(tagContainerId: string): void {
        this.tagContainerId = tagContainerId;
    }

    public getTagContainerId(): string {
        return this.tagContainerId;
    }

    protected getTagContainer()
    {
        return document.getElementById(this.tagContainerId);
    }


    public resetTagContainer(): void {
        if (this.getTagContainer()) {
            this.getTagContainer().innerHTML = '';
        }
    }

    protected addCaption()
    {
        if (this.getTagContainer()) {
            if (!this.hasCaption()) {
                this.getTagContainer().appendChild(this.createCaption());
            }
        }
    }


    protected hasCaption(): boolean {

        let captions = this.getTagContainer().getElementsByTagName('label');

        return (captions.length > 0);

    }

    protected createCaption()
    {
        let element = document.createElement('label');

        element.setAttribute('class', 'small');
        element.appendChild(document.createTextNode(this.tagContainerCaption));

        return element;
    }

    protected addHtmlTag(tag)
    {
        if (this.getTagContainer()) {

            this.getTagContainer().appendChild(this.createHtmlTag(tag));
        }
    }

    protected createHtmlTag(tag)
    {
        let self = this;

        let element = document.createElement('button');

        element.setAttribute('id', tag.id);
        element.appendChild(document.createTextNode(tag.name));
        element.setAttribute('class', 'btn-f-s icon i-x-after');
        element.setAttribute('type', 'button');

        element.addEventListener('click', function (e) {
            // @ts-ignore
            self.removeTagFromSelection(e.target.getAttribute('id'));
            // @ts-ignore
            self.getTagContainer().removeChild(e.target);
            if (self.getTagTypeObjs().length == 0) {
                self.resetTagContainer();
            }

            self.caller.filterSimpleOnChange(self.idElement);
        }, false);

        return element;
    }

    public setTagContainerCaption(tagContainerCaption: string): void {
        this.tagContainerCaption = tagContainerCaption;
    }

    public getTagContainerCaption(): string {
        return this.tagContainerCaption;
    }

    public setTagTypeInfo(tagType){

        if(tagType) {
            this.setTagType(tagType.name + ' ' + tagType.formattedDataset);
            this.setTagTypeObj(tagType);
            this.setIdTagType(tagType.id);
            this.setTagTypes([]);
            this.setIsShowTagTypeSuggestions(false);
        } else {
            this.setTagType('');
            this.setTagTypeObj('');
            this.setIdTagType(null);
            this.setTagTypes([]);
            this.setIsShowTagTypeSuggestions(false);
        }
    }

    public toggleCloseButton(): void {

        let closeBtn = document.getElementById(this.idElement + '-input-close');
        let idTag = this.getTemplateViewModel().idTagType();

        if (idTag == null) {
            closeBtn.classList.remove('is-showing');
        } else {
            closeBtn.classList.add('is-showing');
        }
    }
    public setSelectionMode(selectionMode): void {
        this.getTemplateViewModel().selectionMode(selectionMode);
    }

    public getSelectionMode() {
        return this.getTemplateViewModel().selectionMode();
    }

    public setTagTypes(tagTypes): void {
        this.getTemplateViewModel().tagTypes(tagTypes);
    }

    public getTagTypes() {
        return this.getTemplateViewModel().tagTypes();
    }

    public setIdTagType(idTagType): void {
        this.getTemplateViewModel().idTagType(idTagType);
    }

    public getIdTagType() {
        return this.getTemplateViewModel().idTagType();
    }

    public setIdFilter(idFilter): void {
        this.getTemplateViewModel().idFilter(idFilter);
    }

    public getIdFilter() {
        return this.getTemplateViewModel().idFilter();
    }

    public setTagType(tagType): void {
        this.getTemplateViewModel().tagType(tagType);
    }

    public getTagType() {
        return this.getTemplateViewModel().tagType();
    }

    public setTagTypeObj(tagTypeObj): void {
        this.getTemplateViewModel().tagTypeObj(tagTypeObj);
    }

    public getTagTypeObj() {
        return this.getTemplateViewModel().tagTypeObj();
    }
    public setTagTypeObjs(tagTypeObjs): void {
        this.getTemplateViewModel().tagTypeObjs(tagTypeObjs);
    }

    public getTagTypeObjs() {
        return this.getTemplateViewModel().tagTypeObjs();
    }

    public setOrderBy(orderBy): void {
        this.getTemplateViewModel().orderBy = orderBy;
    }

    public getOrderBy() {
        return this.getTemplateViewModel().orderBy;
    }

    public setOrderByDirection(orderByDirection): void {
        this.getTemplateViewModel().orderByDirection = orderByDirection;
    }

    public getOrderByDirection() {
        return this.getTemplateViewModel().orderByDirection;
    }

    public setIsShowTagTypeSuggestions(isShowTagTypeSuggestions): void {
        this.getTemplateViewModel().isShowTagTypeSuggestions(isShowTagTypeSuggestions);
    }

    public getIsShowTagTypeSuggestions() {
        return this.getTemplateViewModel().isShowTagTypeSuggestions();
    }

    public getTagsForRequest() {
        let tagTypes = this.getTagTypeObjs();
        if (!tagTypes || tagTypes.length == 0) {
            return null;
        }
        return tagTypes.map((t) => {
           return {id: t.id, name: t.name};
        });
    }

    public setSelectedItems(tagTypes): void {
        if (tagTypes && tagTypes.length > 0) {
            if (this.isMultipleSelectionMode()) {
                this.addCaption()
            }
            tagTypes.forEach((tT) => {
                this.appendTagToSelection(tT);
            });
        }
    }

    public removeAllTagTypessFromSelection(): void {
        let tagTypes = [];
        this.setTagTypeObjs(tagTypes);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/filterTagType_template.ts